import React from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import history from "../../../app/routes/history"
import { RoutePaths } from "../../../app/routes/Routes"
import ButtonLink from "./ButtonLink"
import { IconSignOut } from "../../../svg/icons"
import MenuLink from "../../../features/nav/components/MenuLink"
import { signOutUserAction } from "../../../features/account/state/accountActions"
import useSignInStatus from "../../hooks/useSignInStatus"

interface IPropsFromParent {
  isMenuLink?: boolean
}

const SignOutButton: React.FC<IPropsFromParent> = (props: IPropsFromParent) => {
  const { signedIn } = useSignInStatus()
  const dispatch = useDispatch()

  const { t } = useTranslation(["shared"])

  const onClickSignOut = () => {
    dispatch(signOutUserAction())
    history.push(RoutePaths.SIGN_IN)
  }

  const renderMenuButton = (): JSX.Element => {
    return (
      <MenuLink action={onClickSignOut}>
        <IconSignOut className="w-6 h-6 mr-3" /> {t("shared:signout")}
      </MenuLink>
    )
  }

  const renderNormalButton = (): JSX.Element => {
    return (
      <ButtonLink action={onClickSignOut} noPaddingY className="normal-case ml-8" variant="ch-gray-alt">
        {t("shared:signout")} <IconSignOut className="w-6 h-6 ml-2" title={t("shared:signout")} />
      </ButtonLink>
    )
  }
  if (!signedIn) return null
  return props.isMenuLink ? renderMenuButton() : renderNormalButton()
}

export default SignOutButton
